/**
 * Format an ISO datetime string using the tenant's stored timezone.
 * Falls back gracefully if the timezone is invalid.
 */

export function fmtDate(iso: string | null | undefined, timezone = 'UTC'): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('en-US', {
      timeZone: timezone,
      year:  'numeric',
      month: 'short',
      day:   'numeric',
    });
  } catch {
    return new Date(iso).toLocaleDateString();
  }
}

export function fmtDateTime(iso: string | null | undefined, timezone = 'UTC'): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('en-US', {
      timeZone: timezone,
      year:    'numeric',
      month:   'short',
      day:     'numeric',
      hour:    '2-digit',
      minute:  '2-digit',
    });
  } catch {
    return new Date(iso).toLocaleString();
  }
}
